import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import AccordionSection from '../AccordionSection'

import AggregationAudienceCreationImage from './AggregationAudienceCreationImage'

const data = {
  anchorId: `audience-creation`,
  overline: `Aggregation`,
  heading: `Audience Creation`,
  description: `Searching through billions of user actions to find who loaded a particular page more than 3 times in a month isn’t easy. You have to run complex aggregations, set up your data structure so they can be quickly and efficiently queried, and run it all on core infra.`,
  link: `https://www.youtube.com/watch?v=rECHcoGIJNU`,
  linkText: `Watch on Youtube (2,600 views)`,
  accordionSection: SectionWithAccordion.AUDIENCE_CREATION,
}

const AggregationAudienceCreation: FC<PropsWithChildren<unknown>> = () => {
  const { anchorId, overline, heading, description, link, linkText, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{description}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>
                <Typography variant="pLarge">
                  <a href={link}>{linkText}</a>
                </Typography>
              </CopyTextDescriptionSection>
              <AccordionSection section={accordionSection} />
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <StyledSectionContents>
          <AggregationAudienceCreationImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

const StyledSectionContents = styled(Section.Contents)`
  margin: auto;
`

export default AggregationAudienceCreation
